'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$0024$0024anon$00244 from "./presto.-Presto$$anon$4.js";
import * as $j_presto$002etypes$0024$002dAccount$002dId$0024 from "./presto.types$-Account-Id$.js";
import * as $j_presto$002etypes$0024$002dEmail$0024 from "./presto.types$-Email$.js";
import * as $j_presto$002etypes$0024$002dMorbid$002dUser$002dDetails$0024 from "./presto.types$-Morbid-User-Details$.js";
var $p;
/** @constructor */
function $c_Lpresto_Presto$$anon$3() {
  this.baC = null;
  this.bau = null;
  this.bav = false;
  this.baD = null;
  this.baE = false;
  this.baH = null;
  this.baA = null;
  this.baB = false;
  this.baw = null;
  this.bax = false;
  this.bay = null;
  this.baz = false;
  this.baF = false;
  this.baG = false;
  this.baC = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.baH = "MorbidUserDetails";
}
export { $c_Lpresto_Presto$$anon$3 as $c_Lpresto_Presto$$anon$3 };
$p = $c_Lpresto_Presto$$anon$3.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Presto$$anon$3;
/** @constructor */
function $h_Lpresto_Presto$$anon$3() {
}
export { $h_Lpresto_Presto$$anon$3 as $h_Lpresto_Presto$$anon$3 };
$h_Lpresto_Presto$$anon$3.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.baC;
});
$p.M = (function() {
  if ((!this.bav)) {
    this.bau = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bav = true;
  }
  return this.bau;
});
$p.O = (function() {
  if ((!this.baE)) {
    this.baD = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.baE = true;
  }
  return this.baD;
});
$p.E = (function() {
  return this.baH;
});
$p.t = (function() {
  if ((!this.baB)) {
    this.baA = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("email", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("account", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.baB = true;
  }
  return this.baA;
});
$p.N = (function() {
  if ((!this.bax)) {
    this.baw = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dEmail$0024.$m_Lpresto_types$Email$().cJ(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dAccount$002dId$0024.$m_Lpresto_types$AccountId$().bl(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bax = true;
  }
  return this.baw;
});
$p.Q = (function() {
  if ((!this.baz)) {
    this.bay = new $j_presto$002e$002dPresto$0024$0024anon$00244.$c_Lpresto_Presto$$anon$4();
    this.baz = true;
  }
  return this.bay;
});
$p.v = (function() {
  if ((!this.baG)) {
    this.baF = false;
    this.baG = true;
  }
  return this.baF;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee26) => ((p) => \u03b4scrutinee26.Gp(p)))($j_presto$002etypes$0024$002dMorbid$002dUser$002dDetails$0024.$m_Lpresto_types$MorbidUserDetails$())));
});
var $d_Lpresto_Presto$$anon$3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Presto$$anon$3, "presto.Presto$$anon$3", ({
  Nn: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_Presto$$anon$3 as $d_Lpresto_Presto$$anon$3 };
//# sourceMappingURL=presto.-Presto$$anon$3.js.map
